const serverList = [
    {
        title: "调试",
        server: "http://localhost:5000",
    },
    {
        title: "账号",
        server: "",
    },
]
const systemType = 1;
export const config = serverList[systemType];
